import { store } from '@betacrew/jars-flux'
import { put, all, takeLatest, takeEvery, call } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import BoiDataService from '../../../../services/BoiDataService';
import { BOI_FORM_STEPS } from '../../boireportingsection/constants';
import { componentKey, setBeneficiaryDetailId, setFormFields, setIsBenefiarySubmitSuccess, setIsErrorOccurred, setLoadingState, updateFormsPreLoadedData } from './BeneficiaryOwnerSlice';
import { BENEFICIAL_OWNER_LOADING_STATES } from './constants';
import General from '../../../../libs/utility/General';
import { FIELD_TYPES } from '../../../../libs/formdatavalidator/constants';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import Forms from '../../../../libs/utility/formsutility/Forms';

export const { getBenefiaryOwnerFormFields, submitBenefiaryOwner,onDependentFieldChangeGetValues, getBeneficiaryOwnerDetails } = {
	
    getBenefiaryOwnerFormFields: (payload) => {
		return {
			type: "BENEFIARY_OWNER/GET_FORM_FIELDS",
			payload: payload
		}
	},
    submitBenefiaryOwner: (payload) => {
		return {
			type: "BENEFIARY_OWNER/SUBMIT",
			payload: payload
		}
	},
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "BENEFIARY_OWNER/CALCULATE_INFERRED_VALUES",
            payload
        }
    },
    getBeneficiaryOwnerDetails: (payload) => {
        return {
            type: "FILE_BOI/GET_BENEFICIARY_OWNER_DETAILS",
            payload
        }
    },
}

function* getBenefiaryOwnerFormFieldsAsync(action){
    try {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_LOADING }))
        const {formName = BOI_FORM_STEPS.BENEFICIAL_OWNER, beneficialData = null, formsPreLoadedData} = action.payload;

        const response = yield BoiDataService.getBoiFormFields(formName);
        const {Status, Message, Data } = response?.data;

        if(Status){
            if(Data){
                if(beneficialData !== null){
                    let updatedFormsPreLoadedData = {...formsPreLoadedData};
                    const updateFieldsList = Data.map((item) => {
                        const prepopulateField = formsPreLoadedData.hasOwnProperty(item?.FrontEndSource) ? formsPreLoadedData[item?.FrontEndSource] : null;
                        if(beneficialData.hasOwnProperty(item?.Name)){
                            let tempUpdatedFieldObj = {
                                ...item,
                                inputValue: beneficialData[item?.Name],
                                isVisible: ((beneficialData[item?.Name] && beneficialData[item?.Name] !== "false") ? true : item?.isVisible),
                            };
                            if(item?.Type === FIELD_TYPES.MULTISELECTENUM && prepopulateField){
                                let multiSelectEnumOptions = prepopulateField;
                                var inputValueArray = (beneficialData[item?.Name]).split(',');                        
                                if(inputValueArray.length > 0 && inputValueArray[0] !== ""){
                                    var updatedMultiSelectEnumOptions = multiSelectEnumOptions.map(function(option) {
                                        if (inputValueArray.includes(option?.value)) {
                                            return { ...option, checked: true };
                                        }
                                        return option;
                                    });
                                    
                                    updatedFormsPreLoadedData = {
                                        ...updatedFormsPreLoadedData,
                                        [item?.FrontEndSource]: [...updatedMultiSelectEnumOptions],
                                    }
                                }
                            }
                            return tempUpdatedFieldObj
                        }else if (!Array.isArray(prepopulateField) && typeof prepopulateField !== "object" && prepopulateField !== null) {
                            return {
                              ...item,
                              inputValue: prepopulateField,
                            };
                        }else{
                            return item
                        }
                    })
                    yield put(setFormFields(updateFieldsList));
                    yield put(updateFormsPreLoadedData({
                        ...updatedFormsPreLoadedData
                    }));
                }else{
                    yield put(setFormFields(Data));
                }
            }
        }else{
            yield put(addNotifications({
                heading: "Error",
                message: Message,
            }));
            yield put(setIsErrorOccurred(true));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_READY }))
    }
}

function* submitBenefiaryOwnerAsync(action){
    try {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_LOADING }))
        const {formData} = action.payload;
        const response = yield BoiDataService.submitBenefiaryOwner(formData);
        const {Status, Message, Data } = response?.data;

        if(Status){
            if(Data){
                yield put(setBeneficiaryDetailId(Data))
                yield put(setIsBenefiarySubmitSuccess(true));
                yield put(addNotifications({
                    heading: "Success",
                    message: Message,
                    variant: TOASTER_VARIANT.SUCCESS
                }));
            }
        }else{
            yield put(addNotifications({
                heading: "Error",
                message: Message,
            }));
        }
    }catch(error){
        yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message
		}));
    } finally {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_READY }))
    }
}

function* onDependentFieldChangeGetValuesAsync(action){
    try {
        const {formId, year, fieldId, allFields, targetElement} = action.payload;
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.CALCULATE_INFERRED_LOADING }));

        const updatedAllFields = Forms.stringifyFormFields(FIELD_TYPES.FILE_UPLOAD, allFields)

        const response = yield BoiDataService.onDependentFieldChangeGetValues({formId, year, fieldId, allFields: updatedAllFields});
        if(response){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                }));
            }else{
                /* if(response?.data?.Data?.interaction){
                    yield put(updateUserInteractionPopupWResponseObj({
                        ...response.data.Data.interaction
                    }));
                } */
                const responseDataArray = response?.data?.Data?.allFields ?? [];
                let updatedAllFieldsFromResponse = Forms.deStringifyFormFields(FIELD_TYPES.FILE_UPLOAD, responseDataArray ?? [])
                yield put(setFormFields(updatedAllFieldsFromResponse));
                
                if(response?.data?.Data?.PreLoadedData){
                    yield put(updateFormsPreLoadedData({
                        ...response?.data?.Data?.PreLoadedData,
                    }));
                }
            }
        }
        /* if(targetElement){
            yield put(setElementToBeFocused(targetElement))
        } else {
            yield put(setElementToBeFocused(fieldId))
        } */
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.CALCULATE_INFERRED_READY }))
    }
}

function* getBeneficiaryOwnerDetailsAsync(action){
    try {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_LOADING }))

        const { beneficialOwnerDetailId, formName = null, formsPreLoadedData } = action.payload;

        const params = {
            beneficialOwnerDetailId: beneficialOwnerDetailId
        }

        const response = yield BoiDataService.getBeneficiaryOwnerDetails(params);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield call(getBenefiaryOwnerFormFieldsAsync, {payload: {beneficialData: Data[0] ?? {}, formName: formName, formsPreLoadedData: formsPreLoadedData}})
            yield put(setBeneficiaryDetailId(beneficialOwnerDetailId))
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
            yield put(setIsErrorOccurred(true));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: BENEFICIAL_OWNER_LOADING_STATES.GRID_READY }))
    }
}

function* rootSaga() {
	yield all([
		takeLatest(getBenefiaryOwnerFormFields().type, getBenefiaryOwnerFormFieldsAsync),
		takeLatest(submitBenefiaryOwner().type, submitBenefiaryOwnerAsync),
		takeLatest(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
        takeLatest(getBeneficiaryOwnerDetails().type, getBeneficiaryOwnerDetailsAsync),
	]);
}

store.sagaManager.addSaga(componentKey, rootSaga);